import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { Ico_Delete, Ico_Edit, Ico_MenuDots } from "@sagecentral/core-ui";
import { INote, NoteClickSignature } from "models/notes";
import { useState } from "react";

type NoteMenuButtonProps = {
    note: INote;
    onDeleteClick: NoteClickSignature;
    onEditClick: NoteClickSignature;
};

const NoteMenuButton: React.FC<NoteMenuButtonProps> = (props) => {
    const {
        note,
        onDeleteClick,
        onEditClick
    } = props;

    const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    return (
        <>
        <IconButton onClick={handleClick}>
            <Ico_MenuDots/>
        </IconButton>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            <MenuItem onClick={() => onEditClick(note)}>
                <ListItemIcon>
                    <Ico_Edit color='primary'/>
                </ListItemIcon>
                <ListItemText>
                    Edit
                </ListItemText>
            </MenuItem>
            <MenuItem onClick={() => onDeleteClick(note)}>
                <ListItemIcon>
                    <Ico_Delete color='primary'/>
                </ListItemIcon>
                <ListItemText>
                    Delete
                </ListItemText>
            </MenuItem>
        </Menu>        
        </>
    )
};

export default NoteMenuButton;